require('./helpers/bundle-manifest').register(JSON.parse("{\"cbJrf\":\"index.02856a48.js\",\"ha0wd\":\"google-workspace-logo.5a99b23a.png\"}"));